import { cx } from "class-variance-authority";
import { motion } from "motion/react";

import * as styles from "./Shadow.module.scss";

type ShadowProps = {
  position: "top" | "bottom" | "left" | "right";
  className?: string;
};

export const Shadow = ({ className, position }: ShadowProps) => {
  return (
    <motion.div
      // purely decorative, no ARIA role of its own — a stable testid is the
      // only way for consumers/tests to assert on which edge is showing
      data-testid={`shadow-${position}`}
      className={cx(className, styles.shadow, {
        [styles.top]: position === "top",
        [styles.bottom]: position === "bottom",
        [styles.left]: position === "left",
        [styles.right]: position === "right",
      })}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ ease: "linear", duration: 0.1 }}
    />
  );
};
